module.exports = __webpack_public_path__ + "img/abnormal-address-icon@2x.21919be4.png";